import {GetHeaderV2Response_SubBrands} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {
  BORDER,
  BrandTileCompact,
  Button,
  COLORS,
  desktopAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {BrandTileTracked} from '../../BrandHubTracking/BrandTileTracked';
import {BRAND_SHOP_ANCHOR_LIST} from '../../utils/anchorList';
import {useActiveSubBrand} from './utils/useActiveSubBrand';

export const BrandPageSubBrandsList: React.FC<{
  subBrands: GetHeaderV2Response_SubBrands;
}> = ({subBrands}) => {
  const {getBrandState, getBrandRedirectUrl} = useActiveSubBrand({
    subBrands,
    parentBrand: subBrands.parentBrand,
  });

  return (
    <>
      {subBrands.subBrands.map((subBrand, index) => {
        const {brand} = subBrand;
        const state = getBrandState(brand.id);
        const brandPath = getBrandRedirectUrl({
          brand,
          brandPreview: undefined,
        });

        const dataTestId = `BrandLogoSlider_${state}_${brand.name}`;

        return (
          <BrandTileTracked key={brand.id} brand={brand} position={index}>
            <BrandTileLink
              href={brandPath}
              considerScrollTopAnchor
              scrollTopAnchorId={BRAND_SHOP_ANCHOR_LIST.subBrandSlider}
              aria-label={undefined}
              size="fit-width"
              variant="glassy"
              data-is-selected={state === 'selected' ? 'true' : 'false'}
            >
              <BrandTileCompact
                data-testid={dataTestId}
                isSelected={state === 'selected'}
                brandName={brand.name}
                image={subBrand.whiteLogoImage}
              />
            </BrandTileLink>
          </BrandTileTracked>
        );
      })}
    </>
  );
};

const BrandTileLink = styled(Button)`
  &&& {
    // fixes a chrome-bug that makes backdrop-filter not working when a
    // 'mix-blend-mode' is set on the page (is set in the BrandTile)
    backdrop-filter: opacity(1);
    height: 40px;
    min-height: 40px;
    padding-inline: 2px;
    --color: ${COLORS['Text.White']};
    --border-width: 0;

    box-shadow: inset 0 0 0 var(--border-width) var(--border-color);

    &[data-is-selected='true'] {
      --border-width: ${BORDER.Sm};
    }

    ${desktopAndUpLinaria(`
      &:hover {
        --border-width: ${BORDER.Sm};
      }
    `)}
  }
`;
